import loadImage from 'blueimp-load-image';

export default async function fixRotationOfFile(file) {
  return new Promise((resolve) => {
    loadImage(
      file,
      (canvas) => {
        canvas.toBlob(
          (blob) => {
            resolve(blob);
          },
          'image/jpeg',
        );
      },
      { canvas: true, orientation: 1 }
    );
  });
}



// WEBPACK FOOTER //
// ./src/helpers/fixImageOrientation.js